export const BITKUB_MENU_BOT_GRID_DISABLES_KEY = {
  DCA: "DCA",
  GRID: "GRID",
};
